import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FsrhComponent } from './fsrh/fsrh.component';
import { RecommendationsComponent } from './recommendations/recommendations.component';
import {TakingHormonalContraceptionComponent } from './taking-hormonal-contraception/taking-hormonal-contraception.component';
import {Section103Component} from './recomendation-section/section103/section103.component';
import {Section1321Component} from './recomendation-section/section1321/section1321.component';
import {Section1322Component} from './recomendation-section/section1322/section1322.component';

const routes: Routes = [
  {
    path: '',
    component: FsrhComponent,
  },
  {
    path: 'recommendations',
    component: RecommendationsComponent,
  },
  {
    path: 'taking-hormonal-contraception',
    component: TakingHormonalContraceptionComponent,
  },
  {
    path: 'section103',
    component: Section103Component,
  },
  {
    path: 'section1321',
    component: Section1321Component,
  },
  {
    path: 'section1322',
    component: Section1322Component,
  },

  {
    path: '**',
    redirectTo: ''
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
